module.exports = __webpack_public_path__ + "static/media/binary.4fb0b3b5.jpg";